<template>
  <div>
    <base-header type="gradient-warning" class="pb-6 pb-8 pt-5 pt-md-8" />
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <card shadow type="secondary">

            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                  <div class="col-8">

                    <div class="media align-items-center" v-if="id">
                      <a href="#!" class="avatar rounded-circle">
                          <img alt="Image placeholder" :src="getAvatarUrl(user)">
                      </a>
                      <div class="name">
                        <h3 class="name mb-0">{{model.name}}</h3>
                      </div>
                    </div>
                    <h3 class="mb-0" v-else>
                      New Player
                    </h3>
                  </div>
                  <div class="col-4 text-right">
                    <base-button
                      size="sm"
                      type="danger"
                      @click="modals.discardConfirm = true"
                    >
                      Discard Changes
                    </base-button>
                    <base-button
                      size="sm"
                      type="info"
                      @click="saveChanges"
                    >
                      Save Changes
                    </base-button>
                  </div>
              </div>
            </div>

            <template>
              <form @submit.prevent>
                <h6 class="heading-small text-muted mb-4">Player Information</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-md-6">
                      <base-input
                        alternative=""
                        label="Name"
                        placeholder="Name"
                        input-classes="form-control-alternative"
                        v-model="model.name"
                        :error="errors.name"
                      />
                    </div>
                    <div class="col-md-6">
                      <base-input
                        alternative=""
                        label="Email"
                        placeholder="Email"
                        input-classes="form-control-alternative"
                        v-model="model.email"
                        :error="errors.email"
                        type="email"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <base-input
                        alternative=""
                        label="Avatar"
                        placeholder=""
                        input-classes="form-control-alternative"
                        @change="handleFileUpload"
                        :error="errors.avatar"
                        type="file"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 text-right">
                      <base-button
                        type="info"
                        @click="saveChanges"
                      >
                        Save Changes
                      </base-button>
                    </div>
                  </div>
                </div>
              </form>
            </template>

          </card>
        </div>
      </div>
    </div>

    <modal
      :show.sync="modals.discardConfirm"
      gradient="danger"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">Are you sure?</h6>

      <div class="py-3 text-center">
        <i class="fa fa-exclamation-triangle fa-3x"></i>
        <h4 class="heading mt-4">Warning</h4>
        <p>This will discard all of your changes.</p>
      </div>

      <template slot="footer">
        <base-button
          type="white"
          @click="goToNextPage"
        >
          Discard
        </base-button>
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.discardConfirm = false"
        >
          Stay
        </base-button>
      </template>
    </modal>

  </div>
</template>
<script>
import AvatarHelper from '@/helpers/Avatars.js';
import ErrorHandler from '@/helpers/AuthError';

export default {
  props: {
    id: [String, Number],
  },
  data() {
    return {
      playerId: this.id,
      modals: {
        discardConfirm: false,
      },
      user: null,
      model: {
        name: '',
        email: '',
        file: null,
      },
      errors: {
        name: '',
        email: '',
      },
    };
  },
  mounted() {
    if (this.playerId) {
      this.getPlayer();
    }
  },
  methods: {
    checkForSubmissionErrors() {
      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          this.errors[key] = '';
        }
      });
      if (this.model.name === '') {
        this.errors.name = 'This field is required';
      }
      if (this.model.email === '') {
        this.errors.email = 'This field is required';
      }
    },
    getPlayer() {
      this.axios
        .get(`/users/${this.playerId}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.model.name = response.data.Name;
          this.model.email = response.data.email;
          this.user = response.data;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    saveChanges() {
      this.checkForSubmissionErrors();
      let isOk = true;

      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          isOk = false;
        }
      });

      if (!isOk) {
        return;
      }

      if (this.model.file !== null) {
        this.uploadImage()
          .then((response) => {
            if (this.id) {
              return this.updatePlayer(response.data);
            }

            return this.createPlayer(response.data);
          })
          .catch((error) => {
            ErrorHandler.handleError(error);
          });
      } else if (this.id) {
        this.updatePlayer();
      } else {
        this.createPlayer();
      }
    },
    goToNextPage() {
      this.modals.discardConfirm = false;
      if (this.id) {
        this.$router.push({ name: 'players', params: { id: this.playerId } });
      } else {
        this.$router.push({ name: 'players' });
      }
    },
    updatePlayer(avatar) {
      const updatedUser = {
        Name: this.model.name,
        email: this.model.email.toLowerCase(),
        username: this.model.email.toLowerCase(),
        confirmed: true,
        password: this.model.email.toLowerCase(),
      };
      if (avatar !== null) {
        updatedUser.avatar = avatar;
      }
      return this.axios
        .put(`/users/${this.playerId}`, updatedUser, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response);
          // this.goToNextPage();
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    createPlayer(avatar) {
      const newUser = {
        Name: this.model.name,
        email: this.model.email.toLowerCase(),
        username: this.model.email.toLowerCase(),
        confirmed: true,
        password: this.model.email.toLowerCase(),
      };
      if (avatar !== null) {
        newUser.avatar = avatar;
      }
      return this.axios
        .post('/users', newUser, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.playerId = response.data.id;
          this.goToNextPage();
        })
        .catch((error) => {
          console.log(error.response);
          error.response.data.message[0].messages.forEach((message) => {
            this.$notify({
              verticalAlign: 'top',
              horizontalAlign: 'center',
              message: message.message,
              type: 'danger',
            });
          });
        });
    },
    uploadImage() {
      const formData = new FormData();
      formData.append('files', this.model.file);

      return this.axios
        .post('/upload', formData, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        });
    },
    handleFileUpload(e) {
      const files = e.target.files || e.dataTransfer.files;

      if (files.length > 0) {
        const [firstFile] = files;
        this.model.file = firstFile;
      }
    },
    getAvatarUrl(user) {
      if (!user || user.avatar == '') {
        return '';
      }
      return AvatarHelper.getAvatar(user);
    },
  },
};
</script>
<style lang="scss" scoped>
  .avatar{
    margin-right: 1rem;
  }
  .avatar img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
